import { render, staticRenderFns } from "./SMain.vue?vue&type=template&id=7c4b9e5f&scoped=true"
import script from "./SMain.vue?vue&type=script&lang=js"
export * from "./SMain.vue?vue&type=script&lang=js"
import style0 from "./SMain.vue?vue&type=style&index=0&id=7c4b9e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b9e5f",
  null
  
)

export default component.exports